import * as React from 'react'

import { CrossIcon } from 'main/ui'
import { Container, CrossIconContainer, Header, StyledPopover } from './Popover.styles'

interface IProps {
  children: React.ReactNode
  body: React.ReactNode
  isOpen: boolean
  onRequestClose: () => void
  hideCloseButton?: boolean
}

function Popover(props: IProps) {
  const { body, children, hideCloseButton, isOpen, onRequestClose } = props

  return (
    <StyledPopover
      body={
        <Container>
          {!hideCloseButton && (
            <Header>
              <CrossIconContainer onClick={() => onRequestClose()}>
                <CrossIcon />
              </CrossIconContainer>
            </Header>
          )}
          {body}
        </Container>
      }
      isOpen={isOpen}
      enterExitTransitionDurationMs={0}
      preferPlace="below"
      tipSize={0.01} // Disables tip
      onOuterAction={() => onRequestClose()}
    >
      {children}
    </StyledPopover>
  )
}

export default React.memo(Popover)
